var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyChatEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "property-chat-email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "property-chat-email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(24.000000, 28.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 22,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,6.5 C8.16666667,10.1666667 11.3333333,12 14,12 C16.6666667,12 19.8333333,10.1666667 23.5,6.5",
    id: "Line",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyChatEmail);
export default __webpack_public_path__ + "static/media/property-chat-email.6e8cd8f2dd5262824cc292b0cad5c8b0.svg";
export { ForwardRef as ReactComponent };